export const getStatusClassName = (status) => {
  switch (status) {
    case "Prospect": {
      return "defaultStatus";
    }
    case "Ja": {
      return "activeStatus";
    }
    case "Nee": {
      return "errorStatus";
    }
    case "Wachtruimte": {
      return "pendingStatus";
    }
    default: {
      return "defaultStatus";
    }
  }
};

export const getContentLineCount = (htmlString) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, 'text/html');
  
  const pElements = doc.querySelectorAll('p'); 
  const liElements = doc.querySelectorAll('li'); 

  let pCharCount = 0;
  pElements.forEach(p => {
    const contentLength = p.textContent.length;
    if (contentLength > 0) {
      pCharCount += Math.ceil(contentLength / 145);
    } else {
      pCharCount += 1;
    }      
  });

  // Count the characters in <li> tags
  let liCharCount = 0;
  liElements.forEach(li => {
    const contentLength = li.textContent.length;
    if (contentLength > 0) {
      liCharCount += Math.ceil(contentLength / 130);
    } else {
      liCharCount += 1;// for empty line
    }

  });  
  return pCharCount + liCharCount;
}
